import React, {useState} from 'react';
import {toast} from "react-toastify";
import classNames from "classnames";
import s from "../styles.module.css";
import api from "../../../api";

let current;

const InputBox = ({
                      value: old_value,
                      id,
                      disabled,
                      is_read,
                      user_id,
                      score: isNan,
                      setData,
                      data,
                      oldUser,
                      setOldUser
                  }) => {
    const [score, setScore] = useState(old_value || '')

    const handlerSetScore = async (value) => {
        const token = localStorage.getItem('token');

        try {
            if (value === '') {
                setScore(old_value ?? '');
                return;
            }

            const res = await api().get(
                `coach/brigade/score/${value}/${id}/${token}`
            );

            const newValue = res.data.value;

            setScore(newValue);

            setData(prev => ({
                ...prev,
                users: prev.users.map(user => {
                    // Обновляем score
                    if (user.user_id === user_id) {
                        return {
                            ...user,
                            result_figure: res?.data?.result_figure,
                            scores: user.scores.map(sco =>
                                sco?.score_figure_id === id
                                    ? { ...sco, value: newValue }
                                    : sco
                            )
                        };
                    }

                    // Обновляем is_mark
                    if (user.user_id === current) {
                        return { ...user, is_mark: 1 };
                    }

                    return { ...user, is_mark: null };
                })
            }));

        } catch (e) {
            setScore(old_value ?? '');
            if (value !== '') {
                toast.error('Ошибка');
            }
            console.log(e);
        }
    };


    const numberInputOnWheelPreventChange = (e) => {
        e.target.blur()

    }

    const handleCustomUser = async () => {
        current = user_id;

        if (user_id === oldUser) {
            return;
        }

        setOldUser(user_id);

        setData({
            ...data, users: data.users.map((user) => user.user_id === user_id ? ({
                ...user, is_mark: 1
            }) : ({
                ...user, is_mark: null
            }))
        });

        const token = localStorage.getItem('token');

        await api().get(`/coach/brigade/custom/${user_id}/${token}`);
    }

    return (
        <input step={0.01} readOnly={is_read} tabIndex={is_read ? -1 : 0} disabled={disabled} style={{
            minWidth: '52px',
            minHeight: '100%',
        }} value={score} onWheel={numberInputOnWheelPreventChange}
               onChange={(e) => setScore(e.target.value)}
               type={'number'}
               className={classNames(s.figure_box_header_title, s.figure_box_header_title_input)}
               onFocus={(e) => {
                   if (is_read) {
                       e.target.blur();
                   } else {
                       handleCustomUser(e).then(r => {
                       });
                   }
               }}
               onBlur={(e) => handlerSetScore(e.target.value)}
        />
    );
};

export default InputBox;
